module.exports = {"width":32,"height":32,"entries":["type-0","type-1","type-2","type-3","type-4","type-5","type-6","type-7","type-8","type-12","type-13","type-14","type-15"]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/types.json
// module id = 276
// module chunks = 0